import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { Title } from 'components/Title';

import DepositMaturity from './DepositMaturity';
export default function MaturitystatementPage() {
	
	const [pageReady, setPageReady] = useState(true);
	    const [policyno, setPolicyno] = useState('');
	return (
		<main id="MaturitystatementPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('maturitystatement')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <section className="page-section mb-3" >
                    <div className="container-fluid">
                        <div className="grid ">
                            <div className="sm:col-12 lg:col-3 md:col-3 comp-grid" >
                                <div className="">
                                    <div> 
                                        <DataSource   apiPath="components_data/policyno_option_list_30"  >
                                            {({ response }) => {
                                            const dropdownOptions = response?.map(x => ({
                                            label: x.label || x.label, // adjust field
                                            value: String(x.value || x.value) // ensure string
                                            })) || [];
                                            return (
                                            <>
                                            <Dropdown
                                            name="policyno"
                                            value={policyno}
                                            onChange={(e) => setPolicyno(e.value)}
                                            options={dropdownOptions}
                                            optionLabel="label"
                                            optionValue="value"
                                            filter   // 🔍 enables search box
                                            showClear
                                            placeholder="Select a Policy Account"
                                            className="w-500"
                                            />
                                            </>
                                            );
                                            }}
                                        </DataSource>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-section mb-3" >
                    <div className="container-fluid">
                        <div className="grid ">
                            <div className="sm:col-12 comp-grid" >
                                <div className="">
                                    <div>
                                        <DepositMaturity policyno={policyno} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
